import { ConfigProvider as ConfigProvider5, App as AntdApp } from 'antd';
import 'babel-polyfill';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './assets/vendor/font-awesome/css/font-awesome.min.css';
import FullPageLoading from './components/utils/FullPageLoading';
import { initAuth } from './features/auth';
import { isApiMocksEnabled } from './apiMocks/apiMocksEnabled';
import store from './store';
import { themeConfig } from './theme';
import { initChartLibrary } from './assets/charts';
import { initDayjs } from './library/dayjs';

import App from './App';

async function loadDependencies() {
  await initAuth(store.dispatch);
  await initDayjs();
  initChartLibrary();
}

function mountApp() {
  const container = document.querySelector('#root');
  if (!container) {
    console.error('React root container not found');
    return;
  }
  const root = createRoot(container);
  root.render(
    <Suspense fallback={<FullPageLoading />}>
      <ConfigProvider5 prefixCls="ant5" theme={themeConfig}>
        <AntdApp>
          <Provider store={store}>
            <HelmetProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </HelmetProvider>
          </Provider>
        </AntdApp>
      </ConfigProvider5>
    </Suspense>
  );
}

async function runAfterDependencies() {
  if (isApiMocksEnabled) {
    try {
      const { default: startApiMocks } = await import('./apiMocks/client');
      await startApiMocks(true);
    } catch (error) {
      console.log('mocks error', error);
    }
  }
  mountApp();
}

loadDependencies().finally(() => {
  runAfterDependencies().catch(console.error);
});
